import { CustomerType } from "../CustomerType.js";
import { PricingLevel } from "../PricingLevel.js";

export function getCustomerType(pricingLevel: PricingLevel | null | undefined): CustomerType {
	if (pricingLevel === null || pricingLevel === undefined || pricingLevel === PricingLevel.B2c) {
		return CustomerType.B2c;
	}
	return CustomerType.B2b;
}
